module.exports = __webpack_public_path__ + "media/images/prizes/icon_praise-fe8a19756cfb19746991f3d6c1d736e2.svg";